module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAADwBAMAAADMe/ShAAAAElBMVEVHcEyioqKjo6Opqamjo6Ojo6MIIeQfAAAABXRSTlMAnrQCV5qaYD8AAADXSURBVHja7dzRCcIwFIbR6HUAXxzBATQLuEKl2X+V6g6av9DzLXA5XCilNGlNkiRJkiRJ0k66pAbfXpm5j7GEwGNcM+Ax1hA4Iv6CF2BgYGBg4GOD6x4Cn4GBgYGBgYGBZ/UEBgYGBgYGBgYG/s1cYGBgYGBgYC8e0zp95r5bopQ4tuPcknuM3JGRkZGRkZGRD/j2hYyMjIyMjIyMPLXUb4rBL5zIyMjIyMjIyMgzi51ArtQR5EKeV7dlW/4zeU1tOfLArtjdTZW6rapi93NJkiRJkiRpH20xgdN2vbMkIAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/concierce_voucher_left.png
// module id = HchI
// module chunks = 0